// extracted by mini-css-extract-plugin
module.exports = {"Primary":"Primary___OJDlk","Transparent":"Transparent___fQQs0","Danger":"Danger___uBb6q","Minor":"Minor___NKTTR"};